var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-embed',{attrs:{"src":"/trendshop.proxy.web/help/index.html","type":"iframe"}})
}
var staticRenderFns = []

export { render, staticRenderFns }